import { render, staticRenderFns } from "./CourierEditForm.vue?vue&type=template&id=3937f98b&scoped=true&"
import script from "./CourierEditForm.vue?vue&type=script&lang=js&"
export * from "./CourierEditForm.vue?vue&type=script&lang=js&"
import style0 from "./CourierEditForm.vue?vue&type=style&index=0&id=3937f98b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3937f98b",
  null
  
)

export default component.exports